<script>
    import { map_flyTo } from '$lib/app/lib.js';

    let {
        map = null,
        text = null,
        lon = null,
        lat = null,
        icon = ''
    } = $props();
    
    function flyTo() {
        if(map) {
            //map.flyTo({center: [lon, lat], zoom: 10, speed: 15 });
            map_flyTo(map, {center: [lon, lat], zoom: 10, speed: 15 });
        }
    }

</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<span class="text-wrap-rules">
    <span class="flyable-text" role="button" onclick={flyTo}>{text}</span>{#if icon}&nbsp;{@html icon}{/if}
</span>

<style>
.text-wrap-rules {
    overflow-wrap: break-word;
    text-wrap: balance;
}

.flyable-text {
    cursor: zoom-in;
    text-decoration: underline;
    text-decoration-style: dashed;
    text-decoration-skip: spaces edges;
    text-decoration-color: #c7c7c7;
}
</style>
